import React from "react";
import logo from "../../assets/logo/logo.jpg";
import MMFooter from "../Footer/MMFooter";

const MakingMindsLearningFooter = () => {
    return (
        <div>
            <hr className=" border-gray-100 sm:mx-auto dark:border-gray-700 " />
            <footer className="bg-mblack dark:bg-gray-900">
                <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-[60px]">
                    <div className="md:flex md:justify-between">
                        <div className="mb-6 md:mb-0">
                            <a href="/" className="flex items-center">
                                <img src={logo} className="h-8 mr-3" alt=" Logo" />
                                <span className="self-center text-mwhite text-2xl font-bold font-mfont whitespace-nowrap dark:text-white">
                                    Making Minds Technologies
                                </span>
                            </a>
                            <br />
                            <p className="text-lg text-mwhite font-mfont font-semibold dark:text-gray-400">
                                Throbbing Innovation and Solutions
                            </p>
                        </div>
                        <div className="grid grid-cols-1 gap-8 sm:gap-6 sm:grid-cols-3">
                            <div>
                                <h2 className="mb-6 text-lg font-semibold text-mwhite font-mfont dark:text-white">
                                    Our timing
                                </h2>
                                <ul className="text-kblack dark:text-gray-400 font-medium">
                                    <li className="mb-3">
                                        <p className="mr-4 text-mwhite md:mr-6  
               font-semibold font-mfont block  text-md ">
                                            Support Timings: 24/5
                                        </p>
                                    </li>

                                </ul>
                            </div>

                            <div>
                                <h2 className="mb-6 text-lg font-semibold text-mwhite font-mfont dark:text-white">
                                    Email
                                </h2>
                                <ul className="text-kblack dark:text-gray-400 font-medium">
                                    <li className="mb-3">
                                        <a href="mailto:teammakingminds@gmail.com"
                                            target="_blank"
                                            rel="noreferrer" className="mr-4 text-mwhite md:mr-6  hover:underline
               font-semibold font-mfont block  text-md   ">
                                            teammakingminds@gmail.com
                                        </a>
                                    </li>

                                </ul>
                            </div>
                            <div>
                                <h2 className="mb-6 text-lg font-semibold text-mwhite font-mfont dark:text-white">
                                    Follow us on:
                                </h2>
                                <ul className="text-kblack flex flex-row gap-5 dark:text-gray-400 font-medium">
                                    <li className="mb-3">
                                        <a
                                            href="https://www.linkedin.com/company/making-minds-technologies-private-limited/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-white hover:text-gray-400 dark:hover:text-white"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                                <path d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z" fill="#FFF" />
                                                <path d="M5 10C5 9.44772 5.44772 9 6 9H7C7.55228 9 8 9.44771 8 10V18C8 18.5523 7.55228 19 7 19H6C5.44772 19 5 18.5523 5 18V10Z" fill="#FFF" />
                                                <path d="M11 19H12C12.5523 19 13 18.5523 13 18V13.5C13 12 16 11 16 13V18.0004C16 18.5527 16.4477 19 17 19H18C18.5523 19 19 18.5523 19 18V12C19 10 17.5 9 15.5 9C13.5 9 13 10.5 13 10.5V10C13 9.44771 12.5523 9 12 9H11C10.4477 9 10 9.44772 10 10V18C10 18.5523 10.4477 19 11 19Z" fill="#FFF" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 1C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H20ZM20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20Z" fill="#FFF" />
                                            </svg>
                                            <span className="sr-only">linkedin page</span>
                                        </a>
                                    </li>

                                    <li className="mb-3">
                                        <a
                                            href="mailto:teammakingminds@gmail.com"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-white hover:text-gray-400 dark:hover:text-white"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 192 192" fill="none"><path stroke="#FFF" stroke-linejoin="round" stroke-width="12" d="M22 57.265V142c0 5.523 4.477 10 10 10h24V95.056l40 30.278 40-30.278V152h24c5.523 0 10-4.477 10-10V57.265c0-13.233-15.15-20.746-25.684-12.736L96 81.265 47.684 44.53C37.15 36.519 22 44.032 22 57.265Z" /></svg>
                                            <span className="sr-only">gmail page</span>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <MMFooter />
            </footer>

        </div>
    )
}

export default MakingMindsLearningFooter